import React from 'react'
import styles from './styles.module.css'
import { Link } from 'react-static'
import dateFormat from 'dateformat'

export default ({ post }) => (
    <article className={styles.blogPost}>
        <h2>
            <Link to={post.path}>{post.title}</Link>
        </h2>
        <div className={styles.postMeta}>
            {dateFormat(post.date, "dd/mm/yy")}
        </div>
        <div className={styles.body} dangerouslySetInnerHTML={{ __html: post.contents }} />
    </article>
)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/BlogPost/index.js